import React from "react";
import CircleCheckIcon from "@/assets/icons/circle-check";
import clsx from "clsx";
import type { OrderStatus } from "../types";

const statusConfig: Record<
  OrderStatus,
  { label: string; className: string; showCheck: boolean; checkColor?: string }
> = {
  new: {
    label: "New",
    className: "bg-[#E0F2FE] text-[#0369A1]",
    showCheck: false,
  },
  accepted: {
    label: "Accepted",
    className: "bg-[#D1ECF1] text-[#0C5460]",
    showCheck: false,
  },
  ready: {
    label: "Ready",
    className: "bg-[#FEF9C2] text-[#8D5100]",
    showCheck: false,
  },
  delivered: {
    label: "Delivered",
    className: "bg-[#DBFCE7] text-[#016731]",
    showCheck: true,
    checkColor: "#00A63E",
  },
  shipped: {
    label: "Shipped",
    className: "bg-primary/10 text-primary",
    showCheck: false,
  },
  processing: {
    label: "Processing",
    className: "bg-[#FEF9C2] text-[#8D5100]",
    showCheck: false,
  },
  pending: {
    label: "Pending",
    className: "bg-[#FEF3CD] text-[#856404]",
    showCheck: false,
  },
  canceled: {
    label: "Canceled",
    className: "bg-[#F8D7DA] text-[#721C24]",
    showCheck: false,
  },
  confirmed: {
    label: "Confirmed",
    className: "bg-[#D1ECF1] text-[#0C5460]",
    showCheck: true,
    checkColor: "#17A2B8",
  },
  on_the_way: {
    label: "On The Way",
    className: "bg-[#CCE5FF] text-[#004085]",
    showCheck: false,
  },
};

interface StatusPillProps {
  status: OrderStatus;
}

export function StatusPill({ status }: StatusPillProps) {
  const config = statusConfig[status] ?? statusConfig.new;
  return (
    <div className="flex items-center gap-2">
      <span
        className={clsx(
          "inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-sm font-semibold",
          config.className,
        )}
      >
        {config.label}
      </span>
      {config.showCheck && (
        <CircleCheckIcon
          size={20}
          color={config.checkColor}
          className="flex-shrink-0"
        />
      )}
    </div>
  );
}
